module.exports = __webpack_public_path__ + "img/h_aboutthegame.612cb169.svg";